// const API_URL = 'http://localhost:80';
const API_URL = "https://apis.qrtsolutions.com";

export { API_URL };